import { render, staticRenderFns } from "./ProcedureTypeNew.vue?vue&type=template&id=2e16ae90&"
import script from "./ProcedureTypeNew.vue?vue&type=script&lang=js&"
export * from "./ProcedureTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports